﻿import React from 'react';

export interface SliderIndicatorProps {
  length: number;
  active: number;
  // eslint-disable-next-line no-unused-vars
  setActive?: (index: number) => void;
}

const SliderIndicator = ({
  length,
  active,
  setActive,
}: SliderIndicatorProps) => {
  const getClasses = (index: number) => {
    if (index === active) return 'opacity-100 w-16 h-6';
    return 'opacity-30 size-6';
  };

  return (
    <ul className={'flex gap-6 w-fit bg-transparent'}>
      {[...Array(length)].map((_ignore, i) => {

        const accessibilityProps =
          typeof setActive === 'function'
            ? {
              'aria-label': active > i ? 'Forrige spil' : 'Næste spil',
              onKeyDown: (e: React.KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setActive(i);
                }
              }
            }
            : {};

        return (
          <li
            className={`rounded-full bg-neutrals-coolGrey-500 duration-200 list-none ring-opacity-100 focus-visible:ring-primary ${getClasses(i)}`}
            key={`sliderIndicator-${i}`}
            {...accessibilityProps}
          ></li>
        );
      })}
    </ul>
  );
};

export default SliderIndicator;
